import { graphql } from '@apollo/client/react/hoc';
import component from './component';
import articlesQuery from './articlesQuery.graphql';

export default graphql(articlesQuery, {
  props: ({ data: { articles } }) => ({ articles })
})(component);
